<template>
  <DashboardCard :title="title">
    <template #action>
      <div class="flex items-center space-x-2">
        <!-- Time period selector -->
        <select
          v-if="showPeriodSelector"
          v-model="selectedPeriod"
          @change="onPeriodChange"
          class="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="7d">Last 7 days</option>
          <option value="30d">Last 30 days</option>
          <option value="90d">Last 90 days</option>
          <option value="1y">Last year</option>
        </select>

        <!-- Export button -->
        <button
          v-if="showExport"
          @click="exportChart"
          class="text-gray-500 hover:text-gray-700 transition-colors"
        >
          <i class="material-icons text-sm">file_download</i>
        </button>
      </div>
    </template>

    <div class="h-80">
      <highcharts
        v-if="chartOptions"
        :options="chartOptions"
        class="w-full h-full"
      ></highcharts>
      <div v-else class="flex items-center justify-center h-full text-gray-500">
        <div class="text-center">
          <i class="material-icons text-4xl mb-2">insert_chart</i>
          <p>No data available</p>
        </div>
      </div>
    </div>
  </DashboardCard>
</template>

<script>
import { Chart } from "highcharts-vue";
import DashboardCard from "./DashboardCard.vue";

export default {
  name: "ChartWidget",
  components: {
    highcharts: Chart,
    DashboardCard
  },
  props: {
    title: {
      type: String,
      required: true
    },
    chartType: {
      type: String,
      default: "line",
      validator: value =>
        ["line", "area", "column", "pie", "donut"].includes(value)
    },
    data: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    showPeriodSelector: {
      type: Boolean,
      default: true
    },
    showExport: {
      type: Boolean,
      default: true
    },
    colors: {
      type: Array,
      default: () => ["#3B82F6", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6"]
    }
  },
  data() {
    return {
      selectedPeriod: "30d"
    };
  },
  computed: {
    chartOptions() {
      if (!this.data || this.data.length === 0) return null;

      const baseOptions = {
        chart: {
          type: this.chartType === "donut" ? "pie" : this.chartType,
          backgroundColor: "transparent",
          height: 320
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        colors: this.colors,
        legend: {
          enabled: this.chartType === "pie" || this.chartType === "donut"
        },
        tooltip: {
          backgroundColor: "#374151",
          borderColor: "#374151",
          style: {
            color: "#ffffff"
          }
        },
        plotOptions: {
          pie: {
            innerSize: this.chartType === "donut" ? "50%" : "0%",
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          },
          series: {
            animation: {
              duration: 1000
            }
          }
        }
      };

      if (this.chartType === "pie" || this.chartType === "donut") {
        return {
          ...baseOptions,
          series: [
            {
              name: "Value",
              data: this.data
            }
          ]
        };
      } else {
        return {
          ...baseOptions,
          xAxis: {
            categories: this.categories,
            gridLineWidth: 0,
            lineColor: "#E5E7EB"
          },
          yAxis: {
            title: {
              text: null
            },
            gridLineColor: "#F3F4F6"
          },
          series: this.data
        };
      }
    }
  },
  methods: {
    onPeriodChange() {
      this.$emit("period-changed", this.selectedPeriod);
    },
    exportChart() {
      this.$emit("export-chart", this.chartType);
    }
  }
};
</script>
